import React from 'react';
import {
  Checkbox,
  FormControlLabel,
  Typography,
  CircularProgress
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
    RadioButtonUnchecked as RadioButtonDefaultIcon,
    CheckBoxOutlined as CheckCircleOutlineIcon,
    AccessTime as AccessTimeIcon,
    CheckCircle as CheckCircleIcon,
    ReportProblem as ReportProblemIcon
} from '@material-ui/icons/';

const LoadingCheckPae = ({label, status, checked,teme}) => {
    const CheckedComponent = () => {
        switch(status){
            case 1: { // Criado
                return (
                    <CheckCircleOutlineIcon/>
                )
            }

            case 2: { // Enviado para fila
                return (
                    <AccessTimeIcon/>
                )
            }

            case 3: { // Executando
                return (
                    <CircularProgress
                        size={16}
                    />
                )
            }

            case 4: { // Gerado com sucesso
                return (
                    <CheckCircleIcon/>
                )
            }

            case 5: { // Gerado com erro
                return (
                    <ReportProblemIcon/>
                )
            }

            default: {
                return (
                    <RadioButtonDefaultIcon/>
                )
            }
        }
    }

    const color = () =>{
        switch(status) {
            case 4: {
                return (
                    "#19B228"
                )
            }

            case 5: {
                return (
                    "#dca50d"
                )
            }

            default: {
                return (
                    `${teme.primary}`
                )
            }
        }
    }

    const GreenCheckbox = withStyles({
        root: {
            padding: '2px',
            color: color,
            '&$checked': {
                color: color
            },
            '&.MuiIconButton-root.Mui-disabled': {
                color: color,
            }
            },
            checked: {
            color: color
        }
    })((props) => <Checkbox color="default" {...props} />);

  return (
    <FormControlLabel
      control={
        <GreenCheckbox
          disabled
          icon={<CheckedComponent />}
          checkedIcon={<CheckedComponent />}
          checked={checked}
        />
      }
      label={
        <Typography
          style={{
            fontFamily: 'Public Sans',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            color: '#727780'
          }}
        >
          {label}
        </Typography>
      }
    />
  );
};

export default LoadingCheckPae;
